<template>
  <TheMenuLayout>
    <v-row>
      <v-col cols="12">
        <BaseSectionHeader>Documents</BaseSectionHeader>
      </v-col>
      <v-col cols="12" xl="6">
        <v-select
          label="Type de document"
          v-model="kind"
          :items="documentKinds"
          @change="loadDocuments"
          clearable
        />
        <v-select
          v-if="kind !== 'Plannings'"
          label="Matière"
          :items="documentSubjects"
          @change="loadDocuments"
          v-model="subject"
          clearable
        />
        <v-select
          label="Dossier"
          :items="documentFolders"
          @change="loadDocuments"
          v-model="folder"
          clearable
          class="mb-4"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <BaseEmptyState v-if="!filteredDocuments.length">
          Aucun document trouvé correspondant à votre recherche
        </BaseEmptyState>
        <BaseList ref="documents" :items="items" />
        <div class="text-center">
          <v-progress-circular v-if="documentsLoading" indeterminate />
          <BaseButton @click="lazyLoadDocuments" color="primary" v-else>Afficher plus</BaseButton>
        </div>
      </v-col>
    </v-row>
  </TheMenuLayout>
</template>

<script>
import BaseSectionHeader from '@/components/BaseSectionHeader.vue';
import BaseButton from '@/components/BaseButton.vue';
import TheMenuLayout from '@/components/TheMenuLayout.vue';
import BaseEmptyState from '@/components/BaseEmptyState.vue';
import BaseList from '@/components/BaseList.vue';
import { DOCUMENT_KINDS } from '@/constants';

import { mapGetters, mapActions, mapState } from 'vuex';
import { mapFields } from 'vuex-map-fields';

export default {
  name: 'Documents',
  components: {
    BaseSectionHeader,
    BaseButton,
    TheMenuLayout,
    BaseEmptyState,
    BaseList,
  },
  created() {
    this.fetchMe();
    this.fetchDocumentSubjects();
    this.loadDocuments(
      this.page,
      this.kind,
      this.subject,
    );
  },
  data() {
    return {
      documentKinds: DOCUMENT_KINDS,
      page: 1,
      documentsLoading: false,
    };
  },
  computed: {
    ...mapGetters(['filteredDocuments', 'documentFolders']),
    ...mapFields(['filters.documents.kind', 'filters.documents.subject', 'filters.documents.folder']),
    ...mapState('authentication', ['student']),
    ...mapState(['documentSubjects']),
    items() {
      return this.filteredDocuments.map((document) => ({
        key: document.id,
        icon: this.iconByDocument(document),
        title: `${document.subject ? document.subject.name : document.name} - ${document.kind}`,
        titleIcon: document.downloaded ? 'mdi-cloud-check' : 'mdi-cloud',
        titleIconColor: document.downloaded ? 'success' : 'warning',
        subtitles: this.subtitlesForDocument(document),
        onClick: () => this.openDocument(document.id),
      }));
    },
  },
  methods: {
    ...mapActions(['fetchDocuments', 'fetchDocument', 'fetchDocumentSubjects']),
    ...mapActions('authentication', ['fetchMe']),
    loadDocuments(reset = true) {
      if (reset) {
        this.page = 1;
      }
      this.documentsLoading = true;
      this.fetchDocuments({
        page: this.page,
        kind: this.kind,
        subject: this.subject,
      }).then(() => {
        this.documentsLoading = false;
      });
    },
    lazyLoadDocuments() {
      this.page += 1;
      this.loadDocuments(false);
    },
    openDocument(documentId) {
      this.fetchDocument(documentId).then((response) => {
        Object.assign(
          document.createElement('a'),
          { target: '_blank', href: response.data },
        ).click();
      });
    },
    subtitlesForDocument(document) {
      const result = [];
      if (document.chapter) {
        result.push({
          name: this.$t('Chapter'),
          description: document.chapter,
        });
      }
      result.push({
        name: this.$t('Upload date'),
        description: this.$moment(document.created_at).format('L'),
      }, {
        name: this.$t('Sender'),
        description: document.author.name,
      });
      return result;
    },
    iconByDocument(document) {
      if (/image/.test(document.content_type)) {
        return 'mdi-image';
      }
      if (/pdf/.test(document.content_type)) {
        return 'mdi-pdf-box';
      }
      if (/(excel|spreadsheet)/.test(document.content_type)) {
        return 'mdi-file-excel-box';
      }
      if (/word/.test(document.content_type)) {
        return 'mdi-file-word-box';
      }
      if (/video/.test(document.content_type)) {
        return 'mdi-file-video';
      }

      return 'mdi-file';
    },
  },
};
</script>
